/**
 * Coach Sidebar - Now part of the sliding app viewport
 * The sidebar is always visible, attached to the right edge of the app
 */

import { CoachChat } from './CoachChat'

interface CoachSidebarProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
}

export const CoachSidebar = ({ isOpen, setIsOpen }: CoachSidebarProps) => {
  return (
    <div className="h-full w-full">
      {/* Coach content fills the entire sidebar */}
      <CoachChat isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  )
}